import { useMemo } from "react";
import { LayerDefinitionDc, generateId } from "@evergis/api";

import { LayerAttribute } from "components/Dialogs/EditResource/components/Layer/LayerAttributeItem";

export const useLayerAttributes = (layerDefinition?: LayerDefinitionDc): LayerAttribute[] =>
  useMemo(() => {
    if (!layerDefinition || !layerDefinition.attributes) return [];

    return Object.entries(layerDefinition.attributes).map(([attributeName, attribute]) => ({
      ...attribute,
      attributeName,
      columnName: attributeName,
      type: attribute.type,
      id: generateId(),
    }));
  }, [layerDefinition]);
